import React from "react";
import { useNavigate } from "react-router-dom";
import "./HotPicks.css";
import bagImage from "../assets/bag.jpg";

const HotPicks = () => {
  const navigate = useNavigate();

  // Static hot picks data with discount
  const hotPicksData = [
    {
      id: 101,
      name: "Classic Luggage Bag",
      price: 129.99,
      image: bagImage,
      description: "A durable and spacious luggage bag perfect for long trips.",
      discount: "60% off", // Added discount
    },
    {
      id: 201,
      name: "Hard Shell Spinner",
      price: 179.99,
      image: bagImage,
      description: "Impact-resistant hard shell with 360° spinner wheels.",
      discount: "30% off", // Added discount
    },
  ];

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="hot-picks">
      {hotPicksData.map((product) => (
        <div key={product.id} className="hot-pick-item" onClick={() => handleProductClick(product.id)}>
          <div className="hot-pick-image-container">
            <img src={product.image} alt={product.name} />
            <span className="discount-badge">{product.discount}</span>
          </div>
          <h3>{product.name}</h3>
          <p>${product.price.toFixed(2)}</p>
        </div>
      ))}
    </div>
  );
};

export default HotPicks;